// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__9lJXS","separator-gray-400":"Separator_separator-gray-400__Bu4VM","separator-gray-300":"Separator_separator-gray-300__aK5M1"};